/**
 * Safety parse some string to JSON
 */
function JSONparse(content: string | null | undefined) {
  try {
    return JSON.parse(content || '')
  } catch (err) {
    return {}
  }
}

/**
 * Safety parse some string to JSON e retrieve a property from it
 * @param content string to parse to JSON
 * @param property property to retrieve
 * @returns property value or undefined
 */
function getPropertyFrom(content: string | null | undefined, property: string) {
  return JSONparse(content)[property]
}

export { JSONparse, getPropertyFrom }
